import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "regiones",
    "region",
    "RegionForm",
    "/regiones",
);

export default handleActions(reducers, initialState);
